// extracted by mini-css-extract-plugin
export default {"background":"InfoModal_background__vrNeE","modal":"InfoModal_modal__b8Mlf","viddo_modal":"InfoModal_viddo_modal__jrq9w","btn_main":"InfoModal_btn_main__LKMJx"};